export const MAP_ELEMENT_ID = 'national-map';
